import { programImage } from '@/lib/images';

interface ProgramImageTileProps {
  slug: string;
  title: string;
  aspectClassName: string;
}

export function ProgramImageTile({ slug, title, aspectClassName }: ProgramImageTileProps) {
  const image = programImage(slug);

  if (!image) return null;

  return (
    <div className={`${aspectClassName} overflow-hidden bg-neutral-900`}>
      <img
        src={image.src}
        alt={title}
        loading="lazy"
        className="h-full w-full object-cover"
        style={{
          objectPosition: image.objectPosition ?? '50% 50%',
          transform: image.transform,
          transformOrigin: 'center',
        }}
      />
    </div>
  );
}
